var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4492 1.74609V7.07568M1.67578 4.23955V11.4293C1.67578 11.4293 4.45528 14.1643 8.3015 14.1643C12.1483 14.1643 14.9278 11.4293 14.9278 11.4293V4.23955",
    stroke: "url(#paint0_linear_157_654)",
    strokeWidth: 2.31143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_654",
    x1: 11.0625,
    y1: 1.74609,
    x2: 11.0625,
    y2: 14.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1B09"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation2);
export default __webpack_public_path__ + "static/media/education2.8cfe191711d744b839fa8d4ea9a21335.svg";
export { ForwardRef as ReactComponent };